import React from 'react';
import { Link } from 'react-router-dom';
import { CheckIcon } from 'lucide-react';
import { SectionLabel } from './SectionLabel';
import { websiteTiers } from '../data/site';
export function Websites() {
  return <section id="websites" className="border-b border-[#1a1a1a] bg-[#0c0c0c]" data-id="element-516" data-mp="264k68sw55jdf">
      <div className="mx-auto w-full max-w-6xl px-6 py-20 lg:py-28" data-id="element-517" data-mp="215z6svopr3q1">
        <SectionLabel data-id="element-518" data-mp="218v5im8dxwfj">Websites</SectionLabel>

        <div className="mt-8 flex flex-col gap-6 lg:flex-row lg:items-end lg:justify-between" data-id="element-519" data-mp="1dhzg1vrejdbg">
          <h2 className="max-w-2xl text-3xl font-bold leading-tight tracking-tight text-white sm:text-4xl" data-id="element-520" data-mp="18imrn6kvty6r">
            Need the site itself? That&rsquo;s a one-time build.
          </h2>
          <p className="max-w-sm text-sm leading-relaxed text-neutral-500" data-id="element-521" data-mp="1ifhrptwt06n5">
            Paid once, then $30 a month to keep it hosted, fast, and online. You own it either
            way.
          </p>
        </div>

        <div className="mt-14 grid grid-cols-1 gap-6 md:grid-cols-3" data-id="element-522" data-mp="2tu4splri6yrg">
          {websiteTiers.map(t => <article key={t.name} className={`flex flex-col rounded-2xl border p-7 ${t.featured ? 'border-emerald-500/50 bg-[#0e1310]' : 'border-[#1c1c1c] bg-[#0d0d0d]'}`} data-id="element-523" data-mp="1ee33t25dx8ma">
              <div className="flex items-center justify-between gap-3" data-id="element-524" data-mp="1sexb1hgp53jd">
                <h3 className="font-mono text-xs uppercase tracking-[0.18em] text-neutral-400" data-id="element-525" data-mp="vomzs4uhqy14">
                  {t.name}
                </h3>
                {t.featured && <span className="rounded-full bg-emerald-500/15 px-2.5 py-1 font-mono text-[10px] uppercase tracking-[0.15em] text-emerald-500" data-id="element-526" data-mp="10l3nwz1oxce7">
                    Most popular
                  </span>}
              </div>

              <p className="mt-6 flex items-baseline gap-2" data-id="element-527" data-mp="cyot9t6cdczl">
                <span className="text-3xl font-bold tracking-tight text-white" data-id="element-528" data-mp="cw2jrnzw4neq">{t.price}</span>
                <span className="text-sm text-neutral-500" data-id="element-529" data-mp="gx4ebriv4bad">one-time</span>
              </p>
              <p className="mt-2 font-mono text-xs uppercase tracking-[0.15em] text-emerald-500" data-id="element-530" data-mp="1k8bf7d5t6iba">
                {t.hosting}
              </p>

              <ul className="mt-7 space-y-3 border-t border-[#1c1c1c] pt-7" data-id="element-531" data-mp="1u0h6eko8kvpf">
                {t.includes.map(inc => <li key={inc} className="flex gap-2.5 text-sm leading-snug text-neutral-300" data-id="element-532" data-mp="1p2fnbzqt8wdy">
                    <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-emerald-500" aria-hidden="true" data-id="element-533" data-mp="11cbn82ctzerp" />
                    {inc}
                  </li>)}
              </ul>

              <Link to="/contact" className={`mt-8 rounded-full px-4 py-3 text-center text-sm font-semibold transition-colors ${t.featured ? 'bg-emerald-500 text-[#0a0a0a] hover:bg-emerald-400' : 'border border-[#2a2a2a] text-neutral-200 hover:border-emerald-500/60 hover:text-white'}`} data-id="element-534" data-mp="16av8s1niiojj">
                Book a 15-min call
              </Link>
            </article>)}
        </div>
      </div>
    </section>;
}